export default __webpack_public_path__ + "static/media/rgp_pvh_nca_kostana_region.6396b400.png";